import { useEffect, useState } from 'react'

const TYPE_MS = 85
const ERASE_MS = 40
const HOLD_MS = 1400
const GAP_MS = 450

/**
 * Arama kutusunun canlı ipucu (29 Eki 2026, kullanıcı): menüdeki ürün adları
 * harf harf yazılıp silinir, yanında imleç yanıp söner. Kutu boş ve odakta
 * değilken gösteriliyor (SalePage). Hareketi azalt açıksa yalnız ilk ad durur.
 */
export function TypingHint({ words }: { words: string[] }) {
  const [text, setText] = useState('')

  useEffect(() => {
    if (words.length === 0) return
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
      setText(words[0])
      return
    }
    let word = 0
    let len = 0
    let erasing = false
    let timer = 0
    const tick = () => {
      const w = words[word % words.length]
      if (!erasing) {
        len += 1
        setText(w.slice(0, len))
        if (len >= w.length) {
          erasing = true
          timer = window.setTimeout(tick, HOLD_MS)
          return
        }
        timer = window.setTimeout(tick, TYPE_MS)
      } else {
        len -= 1
        setText(w.slice(0, Math.max(0, len)))
        if (len <= 0) {
          erasing = false
          word += 1
          timer = window.setTimeout(tick, GAP_MS)
          return
        }
        timer = window.setTimeout(tick, ERASE_MS)
      }
    }
    timer = window.setTimeout(tick, GAP_MS)
    return () => window.clearTimeout(timer)
  }, [words])

  return (
    <span className="psearch__hint" aria-hidden="true">
      <span className="psearch__hint-label">Ara:</span>
      <span className="psearch__hint-word">{text}</span>
      <i className="psearch__caret" />
    </span>
  )
}
